<div [ngClass]="{'is-visible': isVisible}">
  <svg
    class="password-status-icon"
    width="26px" height="26px"
    viewBox="-20 -200 320 400"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g class="password-status-icon__eye" stroke-width="25" fill="none">
      <g class="password-status-icon__eye-lashes" stroke="currentColor">
        <line x1="140" x2="140" y1="90" y2="180"/>
        <line x1="70" x2="10" y1="60" y2="140"/>
        <line x1="210" x2="270" y1="60" y2="140"/>
      </g>

      <path class="password-status-icon__eye-bottom"
            d="m0,0q140,190 280,0"
            stroke="currentColor"/>
      <path class="password-status-icon__eye-top"
            d="m0,0q140,190 280,0"
            stroke="currentColor"/>

      <circle class="password-status-icon__eye-pupil"
              cx="140" cy="0" r="40" fill="currentColor"
              stroke="none"/>
    </g>
  </svg>
</div>

